import React, { useEffect, useState } from 'react';

import HookSelectFormControl from '../HookSelectFormControl';

import ParticipantsService from 'services/ParticipantsService';

import useResources from 'hooks/useResources';

const HookObserverRelationshipFormControl = (props: any) => {
    const [relationships, setRelationships] = useState([] as any[]);

    const { t } = useResources();

    useEffect(() => {
        setRelationships(ParticipantsService.getRelationships());
    }, []);

    return (
        <HookSelectFormControl
            {...props}
            items={[...relationships.map((s) => ({ value: s.value, title: s.display }))]}
            addEmptyItem={true}
            emptyItemTitle={t(`ui.selectPlaceHolder.relationship`)}
        />
    );
};

export default HookObserverRelationshipFormControl;
